import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './confetti.less'
import { inverseLerp } from 'shared/helpers/math_helpers'

let currentAnimationFrame

class Confetti extends React.Component {
  static propTypes = {
    maxRounds: PropTypes.number,
    numAtoms: PropTypes.number,
    atomSpeed: PropTypes.number,
    fadeStart: PropTypes.number,
    fadeEnd: PropTypes.number,
  }

  static defaultProps = {
    maxRounds: 1,
    numAtoms: 350,
    atomSpeed: 2,
    fadeStart: 0.25,
    fadeEnd: 0.5,
  }

  componentWillUnmount() {
    if (currentAnimationFrame) cancelAnimationFrame(currentAnimationFrame)
  }

  confetti = canvas => {
    const MAX_ROUNDS = this.props.maxRounds
    const NUM_ATOMS = this.props.numAtoms
    const ATOM_SPEED = this.props.atomSpeed
    const FADE_START = this.props.fadeStart
    const FADE_END = this.props.fadeEnd

    const context = canvas.getContext('2d')
    canvas.width = canvas.offsetWidth
    canvas.height = canvas.offsetHeight

    let atoms = []
    function Atom(x, y, rx, ry) {
      this.x = x
      this.y = y
      this.sx = 0
      this.sy = 0
      this.rx = rx
      this.ry = ry
      this.color = { r: 0, g: 0, b: 0 }
      this.round = 0
      this.opacity = 1

      this.draw = cntxt => {
        cntxt.beginPath()
        cntxt.fillStyle = `rgba(${this.color.r}, ${this.color.g}, ${
          this.color.b
        }, ${0.6 * this.opacity})`
        cntxt.arc(this.x + 3, this.y + 3, this.rx, 0, 2 * Math.PI)
        cntxt.fill()
      }
    }

    function update() {
      for (let i = 0; i < NUM_ATOMS; i++) {
        if (atoms[i].round >= MAX_ROUNDS) {
          continue
        }
        atoms[i].x += atoms[i].sx
        atoms[i].y += atoms[i].sy
        if (atoms[i].x > canvas.width) {
          atoms[i].x = 0
        } else if (atoms[i].x < 0) {
          atoms[i].x = canvas.width
        }
        if (atoms[i].y > canvas.height) {
          atoms[i].y = 0
          atoms[i].opacity = 1
          atoms[i].round++
        }
        if (atoms[i].y > canvas.height * FADE_START) {
          atoms[i].opacity = Math.max(
            0,
            Math.min(
              1,
              1 -
                inverseLerp(
                  canvas.height * FADE_START,
                  canvas.height * FADE_END,
                  atoms[i].y
                )
            )
          )
        }
      }
    }

    function render() {
      context.clearRect(0, 0, canvas.width, canvas.height)
      for (let i = 0; i < NUM_ATOMS; i++) {
        if (atoms[i].round < MAX_ROUNDS) {
          atoms[i].draw(context)
        }
      }
    }

    function loop() {
      update()
      render()
      currentAnimationFrame = requestAnimationFrame(loop, canvas)
    }

    function initialize() {
      for (let i = 0; i < NUM_ATOMS; i++) {
        let t = new Atom(
          Math.random() * canvas.width,
          Math.random() * -canvas.height,
          1 + Math.random() * 5,
          1 + Math.random() * 5
        )
        t.sx = Math.random() * ATOM_SPEED * 2 - ATOM_SPEED
        t.sy = Math.random() * ATOM_SPEED + ATOM_SPEED
        t.color = {
          r: parseInt(Math.random() * 70 + 100),
          g: parseInt(Math.random() * 70 + 4),
          b: parseInt(Math.random() * 70 + 135),
        }
        atoms[i] = t
      }
    }

    function main() {
      initialize()
      loop()
    }

    main()
  }

  render() {
    return (
      <canvas
        styleName="confetti-canvas"
        ref={canvas => {
          if (canvas) this.confetti(canvas)
        }}
      />
    )
  }
}

export default cssModules(Confetti, styles)
